import  { AxiosResponse, AxiosError, AxiosResponseHeaders } from "axios"
import axios  from "./index"
import { AuthHeaders, Corporation, MailRecipient } from "../stores/store_types"

const callCorporationsInChargeAPI = (headers: AuthHeaders, successCallback: (headers: AxiosResponseHeaders, results: Array<Corporation>) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/corporations/in_charge",
    { headers: headers }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}
const callCorporationAPI = (headers: AuthHeaders, corporationId: number, successCallback: (headers: AxiosResponseHeaders, results: Corporation) => void, failureCallback: () => void) => {
  axios.get(
    `/api/v1/corporations/${corporationId}`,
    { headers: headers }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}
const callCorporationMonthlyMailRecipientsAPI = (headers: AuthHeaders, corporationId: number, successCallback: (headers: AxiosResponseHeaders, results: Array<MailRecipient>) => void, failureCallback: () => void) => {
  axios.get(
    `/api/v1/corporations/${corporationId}/monthly_mail_recipients`,
    { headers: headers }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}
const callCorporationsNestedTreeAPI = (headers: AuthHeaders, successCallback: (headers: AxiosResponseHeaders, results: Array<Corporation>) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/corporations/nested_tree",
    { headers: headers }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}

export { callCorporationsInChargeAPI, callCorporationAPI, callCorporationMonthlyMailRecipientsAPI, callCorporationsNestedTreeAPI }
